module.exports = "/_next/static/images/ManageYourRiskExposure-ce53f1053dbbf6d2785dcbb5af486342.webp";